import { OrderRow } from "../components/global/OrderRow"
import { CustomButton } from "../../components/global/CustomButton"
import { useState, useContext } from "react"
import { OrdersContext } from "../../contexts/OrdersContext"
import "./adminOrders.css"

export function AdminOrders() {
    const [activeFilter, setActiveFilter] = useState(null)
    const [filter, setFilter] = useState("")

    const ordersContextData = useContext(OrdersContext)
    const orders = ordersContextData.state

    return (
        <div className="orders">
            <h4>Orders</h4>

            <div className="filters d-flex justify-content-end gap-2 mt-5">
                <div><span className="me-2">Status:</span>
                    <select
                        id="filters"
                        className="rounded-1"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}>
                        <option value="Cancelled">Cancelled</option>
                        <option value="Delivered">Delivered</option>
                        <option value="Pending">Pending</option>
                    </select>
                </div>
                <CustomButton
                    color="primary"
                    text="Filter"
                    btnFunction={() => setActiveFilter(filter)}
                />
                <CustomButton
                    color="default"
                    text="Reset"
                    btnFunction={() => setActiveFilter(null)}
                />
            </div>

            <div className="border rounded-1 mt-2 table-wrapper">
                <table className="orders-table mt-1 mb-3">
                    <tbody>
                        <tr className="table-header">
                            <td>Order ID</td>
                            <td>Date</td>
                            <td>Customer</td>
                            <td>Status</td>
                            <td className="text-end pe-5">Amount</td>
                        </tr>
                    </tbody>
                </table>

                {
                    activeFilter === null ?
                        orders && orders.map((e, i) => (
                            <OrderRow key={i} order={e} />
                        ))
                        :
                        orders && orders.filter(a => a.status === activeFilter).map((e, i) => (
                            <OrderRow key={i} order={e} />
                        ))
                }
            </div>

        </div>
    )
}